import { criarUsuario } from '@/uteis/action/volume/usuario'

export const volume = (numeroProcesso, dadosSessao) => {
  return {
    solicitante: criarUsuario(dadosSessao.nomeUsuario, dadosSessao.login, 'LOGIN'),
    numeroProcesso: numeroProcesso
  }
}
